import React from 'react';
import { withLayout } from './withLayout';

const Layout = withLayout((props) => {
  return <div {...props} />;
});

export default Layout;
